import React from 'react';
import { Card, Col, FormGroup, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CustomDatePicker from '../../../../Components/Utility/DatePicker/DatePicker';
import { usePOrderDetailState } from './PODetailProvider';
import noImage from '../../../../assets/images/no-image.png';

function POTopBar() {
  const { poDetailstate, setPoDetailState, disablePoCondition, userInfo } = usePOrderDetailState();
  const { PDetailData } = poDetailstate;
  const { t } = useTranslation('common');

  const handleSelectDateChange = (value) => {
    setPoDetailState((prevState) => ({
      ...prevState,
      poSelectedDate: value,
    }));
  };

  const handleSelectorderChange = (value) => {
    setPoDetailState((prevState) => ({
      ...prevState,
      poOrderNo: value,
    }));
  };

  return (
    <Card className="listing-card pt-1 mt-3">
      <Card.Body>
        <Row className="span_font_size">
          <Col lg={6} className="company-logo-block">
            <figure>
              <img
                src={
                  PDetailData?.image === `images/${userInfo?.company}/logo.png` || PDetailData?.image === `images/${userInfo?.companyURL}/logo.jpg`
                    ? noImage
                    : PDetailData?.image || noImage
                }
                alt=""
              />
            </figure>
          </Col>
          <Col lg={6}>
            <h4 className="mt-3 mb-2">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PO_TOP_BAR.TITLE')}</h4>
            <Row>
              <Col lg={6}>
                <div className="input-group form-floating-label-poDesc fixed-label">
                  <label className="asterisk-req f-14">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PO_TOP_BAR.ORDER_NUMBER_LABEL')}</label>
                  <input
                    type="text"
                    value={poDetailstate?.poOrderNo}
                    className="form-control f-14"
                    disabled={disablePoCondition}
                    onChange={(e) => handleSelectorderChange(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <FormGroup>
                  <label className="text-label mb-0 asterisk-req f-14">
                    {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PO_TOP_BAR.ORDER_DATE_LABEL')}
                  </label>
                  <div className="date">
                    {' '}
                    <div className="input-button-container">
                      <CustomDatePicker
                        dateFormat="dd-MMM-yyyy"
                        valueProp={poDetailstate?.poSelectedDate ? new Date(poDetailstate?.poSelectedDate) : null}
                        name="selectedActualApproveByDate"
                        placeholder={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PO_TOP_BAR.ORDER_DATE_PLACEHOLDER')}
                        onChange={(date) => handleSelectDateChange(date)}
                        disable={disablePoCondition}
                        popperPlace="top-end"
                      />
                    </div>
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default POTopBar;
